var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDocumentText = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M7.3 17.083a.7.7 0 0 1 .7-.7h5a.7.7 0 1 1 0 1.4H8a.7.7 0 0 1-.7-.7M8 12.383a.7.7 0 1 0 0 1.4h8a.7.7 0 1 0 0-1.4z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6.4 2.3a2.1 2.1 0 0 0-2.1 2.1v15.2c0 1.16.941 2.1 2.1 2.1h11.2a2.1 2.1 0 0 0 2.1-2.1V8.331a1.5 1.5 0 0 0-.439-1.06l-4.53-4.532a1.5 1.5 0 0 0-1.062-.439zm-.7 2.1a.7.7 0 0 1 .7-.7h6.9V7A1.7 1.7 0 0 0 15 8.7h3.3v10.9a.7.7 0 0 1-.7.7H6.4a.7.7 0 0 1-.7-.7zm11.61 2.9L14.7 4.69V7a.3.3 0 0 0 .3.3z",
  clipRule: "evenodd"
})));
export default SvgDocumentText;